<template>
  <div v-if="show" class="account-dialog-overlay">
    <div class="account-dialog">
      <h2 class="dialog-title">Login Link Sent</h2>
      <h4 class="dialog-info-instructions">Please check your email for your login link.</h4>
      <div class="dialog-actions">
        <button class="dialog-save-btn" type="button" @click="$emit('close')">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginLinkSentDialog',
  props: {
    show: { type: Boolean, required: true }
  },
  emits: ['close']
};
</script>

<style scoped>
</style>
